<template>
  <div class="spa-reviews-master">
    <div class="spa-reviews-master__header">
      <h2 class="spa-reviews-master__header__title">
        <Lang by-key="reviews-last" />
        <span> ({{ reviewCount }})</span>
      </h2>
      <SplButton
        variant="link-right"
        @click="openSpaReviewForm"
      >
        <Lang by-key="reviews-add" />
      </SplButton>
    </div>

    <div>
      <div class="spa-reviews-list">
        <div
          v-if="reviewsView.length"
          class="spa-reviews-list__list"
        >
          <div
            v-for="review in reviewsView"
            :key="review.uuid"
          >
            <SpaReviewListItem :review="review" />
          </div>
        </div>

        <div
          v-else
          class="spa-reviews-list__empty-list"
        >
          <p>
            <Lang
              by-key="reviews-empty"
              capitalize-first
            />
          </p>
        </div>

        <div
          v-if="thereAreMore"
          class="spa-reviews-list__load-more"
        >
          <SplButton
            variant="link"
            @click="loadMoreReviews"
          >
            <Lang
              by-key="see-more"
              capitalize-first
            />
          </SplButton>
        </div>
      </div>

      <div id="spa-review-form-scroll-target" />

      <Separator v-if="isReviewBoxOpened" />

      <SpaReviewForm
        v-if="isReviewBoxOpened"
        :spa-uuid="spaUUID"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { SpaReview } from '~/core/ts/entity/SpaReview'
import Separator from '../../shared/Separator.vue'
import SpaReviewListItem from '../molecules/SpaReviewListItem.vue'
import SpaReviewForm from './SpaReviewForm.vue'
import SplButton from '../../shared/form/SplButton.vue'

export default defineNuxtComponent({
  components: {
    Separator,
    SpaReviewListItem,
    SpaReviewForm,
    SplButton
  },
  props: {
    reviews: {
      type: Array as PropType<Array<SpaReview>>,
      default: () => [],
    },
    spaUUID: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const MAX = 4

    const isReviewBoxOpened = ref(false)
    const reviewsViewMax = ref(MAX)

    function loadMoreReviews() {
      reviewsViewMax.value = Math.min(reviewsViewMax.value + MAX, props.reviews.length)
    }

    const reviewCount = computed(() => {
      return props.reviews.length
    })

    const reviewsView = computed(() => {
      return props.reviews.slice(0, reviewsViewMax.value)
    })

    const thereAreMore = computed(() => props.reviews.length > reviewsView.value.length)

    function openSpaReviewForm() {
      isReviewBoxOpened.value = true

      setTimeout(() => {
        const target = document.getElementById('spa-review-form-scroll-target')
        if (target) {
          // target.scrollIntoView({ behavior: "smooth" })
          const offset = target.offsetTop - 100

          window.scroll({
            top: offset,
            behavior: 'smooth',
          })
        }
      }, 100)
    }

    return {
      isReviewBoxOpened,
      reviewCount,
      loadMoreReviews,
      thereAreMore,
      reviewsView,
      openSpaReviewForm,
    }
  }
})
</script>

<style lang="scss" scoped>
.spa-reviews-master {
  @apply mt-2;

  &__header {
    @apply px-4;

    @apply flex;
    @apply justify-between;

    &__title {
      @apply my-3;
      @apply text-black;
      @apply text-xl;
      @apply font-semibold;
    }
    .link {
      padding-right: 0;
    }
  }
}

.spa-reviews-list {
  @apply m-4;

  &__list {
    @apply grid;
    @apply grid-cols-1;
    @screen lg {
      @apply grid-cols-2;
      @apply gap-x-8;
      @apply gap-y-8;
    }
    @screen xl {
      @apply gap-x-24;
    }
  }

  &__empty-list {
    @apply my-8;
  }

  &__load-more {
    @apply my-8;
    @apply text-center;
  }
}
</style>
